import React from 'react';

import type { Props } from './types';

import AppErrorBoundary from 'ui/shared/AppError/AppErrorBoundary';
import HeaderAlert from 'ui/snippets/header/HeaderAlert';
import HeaderMobile from 'ui/snippets/header/HeaderMobile';

import * as Layout from './components';

const LayoutDefault = ({ children }: Props) => {
  return (
    <Layout.Container>
      <Layout.NavBar/>
      <HeaderMobile/>
      <Layout.MainArea>
        <Layout.SideBar/>
        <Layout.MainContent>
          <Layout.TopRow/>
          <Layout.MainColumn>
            <HeaderAlert/>
            <AppErrorBoundary>
              <Layout.Content>
                { children }
              </Layout.Content>
            </AppErrorBoundary>
          </Layout.MainColumn>
        </Layout.MainContent>
      </Layout.MainArea>
      { /* <Layout.Footer/> */ }
    </Layout.Container>
  );
};

export default LayoutDefault;
